import SidebarBookingsLogsRoute from 'uplisting-frontend/pods/-sidebar/bookings/logs/route';

export default class ProtectionOverviewBookingsLogsRoute extends SidebarBookingsLogsRoute {
  parentRoute = 'protection.overview.bookings';
}
